module.exports = __webpack_public_path__ + "static/media/brev-b.4af65ea1.mp3";